import CancellableHelper from "@/requests/CancellableHelper";
import { KsefIntegration } from "@/models/api/administration/contractors/ContractorExportIntegrationSettingResponse";

//#region routes
export const URL_GET_KSEF_INTEGRATION_SETTING = "/ContractorAdministration/${ContractorId}/KSEFIntegration";
export const URL_POST_SAVE_KSEF_INTEGRATION_SETTING = "/ContractorAdministration/${ContractorId}/KSEFIntegration";
//#endregion

const _getContractorExportAndIntegrationsSetting = new CancellableHelper<KsefIntegration>(
  URL_GET_KSEF_INTEGRATION_SETTING,
  KsefIntegration
);
export const getContractorKsefIntegrationsSetting = async (contractorId: string): Promise<KsefIntegration> => {
  return await _getContractorExportAndIntegrationsSetting.get({
    ContractorId: contractorId,
  });
};

const _saveKsefIntegrationSetting = new CancellableHelper<null>(URL_POST_SAVE_KSEF_INTEGRATION_SETTING, null, true);
export const saveKsefIntegrationSetting = async (contractorId: string, body: object): Promise<null> => {
  return _saveKsefIntegrationSetting.post({ ContractorId: contractorId }, body);
};
